/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './home.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/intl.service';
import * as import10 from '../shared/meta.service';
import * as import11 from '../shared/content.service';
import * as import12 from '../shared/utils.service';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '@angular/router/src/router';
import * as import16 from '@angular/core/src/metadata/view';
import * as import17 from '@angular/core/src/linker/component_factory';
import * as import18 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import19 from '../shared/searchable-contents.component.ngfactory';
import * as import20 from './content-specials.component.ngfactory';
import * as import21 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import23 from '../shared/intl.pipe';
import * as import24 from '../shared/truncate.pipe';
import * as import25 from '../shared/search.service';
import * as import26 from '../shared/search-elasticsearch.service';
import * as import27 from '@angular/core/src/linker/template_ref';
import * as import28 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import29 from '@angular/common/src/directives/ng_switch';
import * as import30 from '../shared/searchable-contents.component';
import * as import31 from '@angular/common/src/directives/ng_for';
import * as import32 from './content-specials.component';
import * as import33 from '@angular/common/src/directives/ng_if';
import * as import34 from '../shared/loading-indicator.ngfactory';
import * as import35 from '../shared/loading-indicator';
import * as import36 from '@angular/core/src/security';
import * as import37 from './content-records-featured.component.ngfactory';
import * as import38 from './content-records-featured.component';
export class Wrapper_HomeComponent {
  context:import0.HomeComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this.changed = false;
    this.context = new import0.HomeComponent(p0,p1,p2,p3,p4,p5,p6,p7);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_HomeComponent_Host:import2.RenderComponentType = (null as any);
class _View_HomeComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _HomeComponent_0_4:Wrapper_HomeComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent_Host0,renderType_HomeComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_HomeComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._HomeComponent_0_4 = new Wrapper_HomeComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.IntlService),this.parentInjector.get(import10.MetaService),this.parentInjector.get(import11.ContentService),this.parentInjector.get(import12.UtilsService),new import13.ElementRef(this._el_0),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router));
    this._appEl_0.initComponent(this._HomeComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._HomeComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.HomeComponent) && (0 === requestNodeIndex))) { return this._HomeComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._HomeComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._HomeComponent_0_4.context.ngAfterContentChecked(); }
    this._HomeComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HomeComponent_0_4.context.ngAfterViewInit(); } }
  }
}
function viewFactory_HomeComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_HomeComponent_Host === (null as any))) { (renderType_HomeComponent_Host = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_HomeComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const HomeComponentNgFactory:import17.ComponentFactory<import0.HomeComponent> = new import17.ComponentFactory<import0.HomeComponent>('ng-component',viewFactory_HomeComponent_Host0,import0.HomeComponent);
const styles_HomeComponent:any[] = ([] as any[]);
var renderType_HomeComponent:import2.RenderComponentType = (null as any);
class _View_HomeComponent0 extends import1.AppView<import0.HomeComponent> {
  _text_0:any;
  _el_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _el_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _NgSwitch_36_3:import18.Wrapper_NgSwitch;
  _SearchableContentsComponent_36_4:import19.Wrapper_SearchableContentsComponent;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _anchor_54:any;
  /*private*/ _appEl_54:import3.AppElement;
  _TemplateRef_54_5:any;
  _NgSwitchCase_54_6:import18.Wrapper_NgSwitchCase;
  _text_55:any;
  _anchor_56:any;
  /*private*/ _appEl_56:import3.AppElement;
  _TemplateRef_56_5:any;
  _NgSwitchCase_56_6:import18.Wrapper_NgSwitchCase;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _el_62:any;
  _text_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _el_68:any;
  _ContentSpecialsComponent_68_3:import20.Wrapper_ContentSpecialsComponent;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _text_89:any;
  _anchor_90:any;
  /*private*/ _appEl_90:import3.AppElement;
  _TemplateRef_90_5:any;
  _NgFor_90_6:import21.Wrapper_NgFor;
  _text_91:any;
  _text_92:any;
  _text_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _text_99:any;
  _text_100:any;
  _text_101:any;
  _text_102:any;
  _anchor_103:any;
  /*private*/ _appEl_103:import3.AppElement;
  _TemplateRef_103_5:any;
  _NgIf_103_6:import22.Wrapper_NgIf;
  _text_104:any;
  _text_105:any;
  _anchor_106:any;
  /*private*/ _appEl_106:import3.AppElement;
  _TemplateRef_106_5:any;
  _NgIf_106_6:import22.Wrapper_NgIf;
  _text_107:any;
  _el_108:any;
  _text_109:any;
  _el_110:any;
  _text_111:any;
  _el_112:any;
  _text_113:any;
  _el_114:any;
  _text_115:any;
  _el_116:any;
  _text_117:any;
  _text_118:any;
  _text_119:any;
  _text_120:any;
  _text_121:any;
  _text_122:any;
  /*private*/ _expr_141:any;
  _pipe_intl_0:import23.IntlPipe;
  _pipe_intl_0_0:any;
  /*private*/ _expr_144:any;
  _pipe_intl_0_1:any;
  /*private*/ _expr_146:any;
  _pipe_intl_0_2:any;
  /*private*/ _expr_148:any;
  _pipe_intl_0_3:any;
  /*private*/ _expr_150:any;
  _pipe_intl_0_4:any;
  _pipe_truncate_1:import24.TruncatePipe;
  /*private*/ _expr_153:any;
  _pipe_intl_0_5:any;
  /*private*/ _expr_155:any;
  _pipe_intl_0_6:any;
  /*private*/ _expr_157:any;
  _pipe_intl_0_7:any;
  /*private*/ _expr_159:any;
  _pipe_intl_0_9:any;
  /*private*/ _expr_161:any;
  _pipe_intl_0_13:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent0,renderType_HomeComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_141 = import7.UNINITIALIZED;
    this._expr_144 = import7.UNINITIALIZED;
    this._expr_146 = import7.UNINITIALIZED;
    this._expr_148 = import7.UNINITIALIZED;
    this._expr_150 = import7.UNINITIALIZED;
    this._expr_153 = import7.UNINITIALIZED;
    this._expr_155 = import7.UNINITIALIZED;
    this._expr_157 = import7.UNINITIALIZED;
    this._expr_159 = import7.UNINITIALIZED;
    this._expr_161 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_1 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray8(6,'class','fill full-screen','id','full-screen-home','style','background-image:url(\'/data/images/platine-v2-home-web-clean.jpg\'); position: relative'),(null as any));
    this._text_2 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_1,'div',new import4.InlineArray2(2,'class','opacity-super-light bg-dark-gray'),(null as any));
    this._text_4 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_1,'div',new import4.InlineArray2(2,'class','slider-typography text-center'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_5,'div',new import4.InlineArray2(2,'class','slider-text-middle-main pull-left'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n            ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_7,'div',new import4.InlineArray2(2,'class','row slider-home slider-text-middle padding-left-right-px'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._text_11 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','text-center col-sm-5 col-lg-4'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                    ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'a',new import4.InlineArray2(2,'class','highlight-link-text xs-line-height-18 pointer highlight-button highlight-button-cover btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n                    ',(null as any));
    this._el_17 = import4.createRenderElement(this.renderer,this._el_12,'h1',new import4.InlineArray2(2,'class','white-text font-weight-100 letter-spacing-2'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._el_19 = import4.createRenderElement(this.renderer,this._el_17,'br',new import4.InlineArray2(2,'class','xs-display-none'),(null as any));
    this._text_20 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_21 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._text_22 = this.renderer.createText(this._el_9,'\n            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_7,'\n        ',(null as any));
    this._text_24 = this.renderer.createText(this._el_5,'\n    ',(null as any));
    this._text_25 = this.renderer.createText(this._el_1,'\n    ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_1,'div',new import4.InlineArray2(2,'class','scroll-down'),(null as any));
    this._el_27 = import4.createRenderElement(this.renderer,this._el_26,'a',new import4.InlineArray2(2,'class','pointer inner-link'),(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_27,'i',new import4.InlineArray2(2,'class','fa fa-angle-down'),(null as any));
    this._text_29 = this.renderer.createText(this._el_1,'\n',(null as any));
    this._text_30 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_31 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_32 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-section wow fadeIn'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n    ',(null as any));
    this._el_34 = import4.createRenderElement(this.renderer,this._el_32,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n\n        ',(null as any));
    this._el_36 = import4.createRenderElement(this.renderer,this._el_34,'div',new import4.InlineArray8(8,'class','row col-md-12','context','record','pageSize','12','searchable-contents',''),(null as any));
    this._NgSwitch_36_3 = new import18.Wrapper_NgSwitch();
    this._SearchableContentsComponent_36_4 = new import19.Wrapper_SearchableContentsComponent(this.parentInjector.get(import11.ContentService),this.parentInjector.get(import25.SearchService),this.parentInjector.get(import12.UtilsService),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router),this.parentInjector.get(import26.ElasticSearchService));
    this._text_37 = this.renderer.createText(this._el_36,'\n            ',(null as any));
    this._el_38 = import4.createRenderElement(this.renderer,this._el_36,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._el_40 = import4.createRenderElement(this.renderer,this._el_38,'div',new import4.InlineArray2(2,'class','col-md-12 text-center'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                    ',(null as any));
    this._el_42 = import4.createRenderElement(this.renderer,this._el_40,'h3',new import4.InlineArray2(2,'class','section-title section-title-services no-padding-bottom'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'',(null as any));
    this._text_44 = this.renderer.createText(this._el_40,'\n                ',(null as any));
    this._text_45 = this.renderer.createText(this._el_38,'\n\n                ',(null as any));
    this._el_46 = import4.createRenderElement(this.renderer,this._el_38,'div',new import4.InlineArray2(2,'class','col-md-5 col-sm-11 margin-five center-col text-center'),(null as any));
    this._text_47 = this.renderer.createText(this._el_46,'\n                    ',(null as any));
    this._el_48 = import4.createRenderElement(this.renderer,this._el_46,'h4',new import4.InlineArray2(2,'class','gray-text'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'',(null as any));
    this._text_50 = this.renderer.createText(this._el_46,'\n                ',(null as any));
    this._text_51 = this.renderer.createText(this._el_38,'\n            ',(null as any));
    this._text_52 = this.renderer.createText(this._el_36,'\n\n            ',(null as any));
    this._text_53 = this.renderer.createText(this._el_36,'\n            ',(null as any));
    this._anchor_54 = this.renderer.createTemplateAnchor(this._el_36,(null as any));
    this._appEl_54 = new import3.AppElement(54,36,this,this._anchor_54);
    this._TemplateRef_54_5 = new import27.TemplateRef_(this._appEl_54,viewFactory_HomeComponent1);
    this._NgSwitchCase_54_6 = new import18.Wrapper_NgSwitchCase(this._appEl_54.vcRef,this._TemplateRef_54_5,this._NgSwitch_36_3.context);
    this._text_55 = this.renderer.createText(this._el_36,'\n\n            ',(null as any));
    this._anchor_56 = this.renderer.createTemplateAnchor(this._el_36,(null as any));
    this._appEl_56 = new import3.AppElement(56,36,this,this._anchor_56);
    this._TemplateRef_56_5 = new import27.TemplateRef_(this._appEl_56,viewFactory_HomeComponent2);
    this._NgSwitchCase_56_6 = new import18.Wrapper_NgSwitchCase(this._appEl_56.vcRef,this._TemplateRef_56_5,this._NgSwitch_36_3.context);
    this._text_57 = this.renderer.createText(this._el_36,'\n\n        ',(null as any));
    this._text_58 = this.renderer.createText(this._el_34,'\n\n    ',(null as any));
    this._text_59 = this.renderer.createText(this._el_32,'\n\n    ',(null as any));
    this._el_60 = import4.createRenderElement(this.renderer,this._el_32,'div',new import4.InlineArray2(2,'class','learn-more row col-md-12 col-sm-12 center-col text-center'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n        ',(null as any));
    this._el_62 = import4.createRenderElement(this.renderer,this._el_60,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_63 = this.renderer.createText(this._el_62,'',(null as any));
    this._text_64 = this.renderer.createText(this._el_60,'\n    ',(null as any));
    this._text_65 = this.renderer.createText(this._el_32,'\n',(null as any));
    this._text_66 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_67 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_68 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray4(4,'class','bg-gray wow fadeIn','content-specials',''),(null as any));
    this._ContentSpecialsComponent_68_3 = new import20.Wrapper_ContentSpecialsComponent(this.parentInjector.get(import11.ContentService),this.parentInjector.get(import12.UtilsService),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router),this.parentInjector.get(import26.ElasticSearchService));
    this._text_69 = this.renderer.createText(this._el_68,'\n    ',(null as any));
    this._el_70 = import4.createRenderElement(this.renderer,this._el_68,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n\n        ',(null as any));
    this._el_72 = import4.createRenderElement(this.renderer,this._el_70,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n            ',(null as any));
    this._el_74 = import4.createRenderElement(this.renderer,this._el_72,'div',new import4.InlineArray2(2,'class','col-md-12 text-center'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'\n                ',(null as any));
    this._el_76 = import4.createRenderElement(this.renderer,this._el_74,'h3',new import4.InlineArray2(2,'class','section-title section-title-services no-padding-bottom'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'',(null as any));
    this._text_78 = this.renderer.createText(this._el_74,'\n            ',(null as any));
    this._text_79 = this.renderer.createText(this._el_72,'\n\n            ',(null as any));
    this._el_80 = import4.createRenderElement(this.renderer,this._el_72,'div',new import4.InlineArray2(2,'class','col-md-5 col-sm-11 margin-five center-col text-center'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                ',(null as any));
    this._el_82 = import4.createRenderElement(this.renderer,this._el_80,'h4',new import4.InlineArray2(2,'class','gray-text'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'',(null as any));
    this._text_84 = this.renderer.createText(this._el_80,'\n            ',(null as any));
    this._text_85 = this.renderer.createText(this._el_72,'\n        ',(null as any));
    this._text_86 = this.renderer.createText(this._el_70,'\n\n        ',(null as any));
    this._el_87 = import4.createRenderElement(this.renderer,this._el_70,'div',new import4.InlineArray2(2,'class','row margin-five no-margin-bottom'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'\n            ',(null as any));
    this._text_89 = this.renderer.createText(this._el_87,'\n            ',(null as any));
    this._anchor_90 = this.renderer.createTemplateAnchor(this._el_87,(null as any));
    this._appEl_90 = new import3.AppElement(90,87,this,this._anchor_90);
    this._TemplateRef_90_5 = new import27.TemplateRef_(this._appEl_90,viewFactory_HomeComponent4);
    this._NgFor_90_6 = new import21.Wrapper_NgFor(this._appEl_90.vcRef,this._TemplateRef_90_5,this.parentInjector.get(import28.IterableDiffers),this.ref);
    this._text_91 = this.renderer.createText(this._el_87,'\n            ',(null as any));
    this._text_92 = this.renderer.createText(this._el_87,'\n        ',(null as any));
    this._text_93 = this.renderer.createText(this._el_70,'\n    ',(null as any));
    this._text_94 = this.renderer.createText(this._el_68,'\n\n    ',(null as any));
    this._el_95 = import4.createRenderElement(this.renderer,this._el_68,'div',new import4.InlineArray2(2,'class','learn-more col-md-12 col-sm-12 center-col text-center'),(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'\n        ',(null as any));
    this._el_97 = import4.createRenderElement(this.renderer,this._el_95,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'',(null as any));
    this._text_99 = this.renderer.createText(this._el_95,'\n    ',(null as any));
    this._text_100 = this.renderer.createText(this._el_68,'\n\n',(null as any));
    this._text_101 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_102 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_103 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_103 = new import3.AppElement(103,(null as any),this,this._anchor_103);
    this._TemplateRef_103_5 = new import27.TemplateRef_(this._appEl_103,viewFactory_HomeComponent5);
    this._NgIf_103_6 = new import22.Wrapper_NgIf(this._appEl_103.vcRef,this._TemplateRef_103_5);
    this._text_104 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_105 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_106 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_106 = new import3.AppElement(106,(null as any),this,this._anchor_106);
    this._TemplateRef_106_5 = new import27.TemplateRef_(this._appEl_106,viewFactory_HomeComponent7);
    this._NgIf_106_6 = new import22.Wrapper_NgIf(this._appEl_106.vcRef,this._TemplateRef_106_5);
    this._text_107 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_108 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','section-pull-up'),(null as any));
    this._text_109 = this.renderer.createText(this._el_108,'\n    ',(null as any));
    this._el_110 = import4.createRenderElement(this.renderer,this._el_108,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_111 = this.renderer.createText(this._el_110,'\n        ',(null as any));
    this._el_112 = import4.createRenderElement(this.renderer,this._el_110,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_113 = this.renderer.createText(this._el_112,'\n            ',(null as any));
    this._el_114 = import4.createRenderElement(this.renderer,this._el_112,'div',new import4.InlineArray2(2,'class','col-md-12 col-sm-12 center-col text-center margin-three'),(null as any));
    this._text_115 = this.renderer.createText(this._el_114,'\n                ',(null as any));
    this._el_116 = import4.createRenderElement(this.renderer,this._el_114,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_117 = this.renderer.createText(this._el_116,'',(null as any));
    this._text_118 = this.renderer.createText(this._el_114,'\n            ',(null as any));
    this._text_119 = this.renderer.createText(this._el_112,'\n        ',(null as any));
    this._text_120 = this.renderer.createText(this._el_110,'\n    ',(null as any));
    this._text_121 = this.renderer.createText(this._el_108,'\n\n',(null as any));
    this._text_122 = this.renderer.createText(parentRenderNode,'\n\n\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_14,'click',this.eventHandler(this._handle_click_14_0.bind(this)));
    this._pipe_intl_0 = new import23.IntlPipe();
    this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_intl_0_2 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_1:Function = this.renderer.listen(this._el_27,'click',this.eventHandler(this._handle_click_27_0.bind(this)));
    this._pipe_intl_0_3 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_intl_0_4 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_truncate_1 = new import24.TruncatePipe();
    var disposable_2:Function = this.renderer.listen(this._el_62,'click',this.eventHandler(this._handle_click_62_0.bind(this)));
    this._pipe_intl_0_5 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_intl_0_6 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_intl_0_7 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_3:Function = this.renderer.listen(this._el_97,'click',this.eventHandler(this._handle_click_97_0.bind(this)));
    this._pipe_intl_0_9 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_4:Function = this.renderer.listen(this._el_116,'click',this.eventHandler(this._handle_click_116_0.bind(this)));
    this._pipe_intl_0_13 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._el_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._anchor_54,
      this._text_55,
      this._anchor_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._text_89,
      this._anchor_90,
      this._text_91,
      this._text_92,
      this._text_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._text_99,
      this._text_100,
      this._text_101,
      this._text_102,
      this._anchor_103,
      this._text_104,
      this._text_105,
      this._anchor_106,
      this._text_107,
      this._el_108,
      this._text_109,
      this._el_110,
      this._text_111,
      this._el_112,
      this._text_113,
      this._el_114,
      this._text_115,
      this._el_116,
      this._text_117,
      this._text_118,
      this._text_119,
      this._text_120,
      this._text_121,
      this._text_122
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (54 === requestNodeIndex))) { return this._TemplateRef_54_5; }
    if (((token === import29.NgSwitchCase) && (54 === requestNodeIndex))) { return this._NgSwitchCase_54_6.context; }
    if (((token === import27.TemplateRef) && (56 === requestNodeIndex))) { return this._TemplateRef_56_5; }
    if (((token === import29.NgSwitchCase) && (56 === requestNodeIndex))) { return this._NgSwitchCase_56_6.context; }
    if (((token === import29.NgSwitch) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 57)))) { return this._NgSwitch_36_3.context; }
    if (((token === import30.SearchableContentsComponent) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 57)))) { return this._SearchableContentsComponent_36_4.context; }
    if (((token === import27.TemplateRef) && (90 === requestNodeIndex))) { return this._TemplateRef_90_5; }
    if (((token === import31.NgFor) && (90 === requestNodeIndex))) { return this._NgFor_90_6.context; }
    if (((token === import32.ContentSpecialsComponent) && ((68 <= requestNodeIndex) && (requestNodeIndex <= 100)))) { return this._ContentSpecialsComponent_68_3.context; }
    if (((token === import27.TemplateRef) && (103 === requestNodeIndex))) { return this._TemplateRef_103_5; }
    if (((token === import33.NgIf) && (103 === requestNodeIndex))) { return this._NgIf_103_6.context; }
    if (((token === import27.TemplateRef) && (106 === requestNodeIndex))) { return this._TemplateRef_106_5; }
    if (((token === import33.NgIf) && (106 === requestNodeIndex))) { return this._NgIf_106_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_36_0_0:any = this._SearchableContentsComponent_36_4.context.loading;
    this._NgSwitch_36_3.check_ngSwitch(currVal_36_0_0,throwOnChange,false);
    this._NgSwitch_36_3.detectChangesInInputProps(this,this._el_36,throwOnChange);
    const currVal_36_1_0:any = 'record';
    this._SearchableContentsComponent_36_4.check_context(currVal_36_1_0,throwOnChange,false);
    const currVal_36_1_1:any = '12';
    this._SearchableContentsComponent_36_4.check_pageSize(currVal_36_1_1,throwOnChange,false);
    const currVal_36_1_2:any = true;
    this._SearchableContentsComponent_36_4.check_active(currVal_36_1_2,throwOnChange,false);
    this._SearchableContentsComponent_36_4.detectChangesInInputProps(this,this._el_36,throwOnChange);
    const currVal_54_0_0:any = true;
    this._NgSwitchCase_54_6.check_ngSwitchCase(currVal_54_0_0,throwOnChange,false);
    this._NgSwitchCase_54_6.detectChangesInInputProps(this,this._anchor_54,throwOnChange);
    const currVal_56_0_0:any = false;
    this._NgSwitchCase_56_6.check_ngSwitchCase(currVal_56_0_0,throwOnChange,false);
    this._NgSwitchCase_56_6.detectChangesInInputProps(this,this._anchor_56,throwOnChange);
    this._ContentSpecialsComponent_68_3.detectChangesInInputProps(this,this._el_68,throwOnChange);
    const currVal_90_0_0:any = this._ContentSpecialsComponent_68_3.context.dbContentsLimited(4);
    this._NgFor_90_6.check_ngForOf(currVal_90_0_0,throwOnChange,false);
    this._NgFor_90_6.detectChangesInInputProps(this,this._anchor_90,throwOnChange);
    const currVal_103_0_0:any = ((this.context.config.data == (null as any))? (null as any): this.context.config.data.HOME.FEATURED);
    this._NgIf_103_6.check_ngIf(currVal_103_0_0,throwOnChange,false);
    this._NgIf_103_6.detectChangesInInputProps(this,this._anchor_103,throwOnChange);
    const currVal_106_0_0:any = (this.context.about && this.context.currentLanguage);
    this._NgIf_106_6.check_ngIf(currVal_106_0_0,throwOnChange,false);
    this._NgIf_106_6.detectChangesInInputProps(this,this._anchor_106,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_141:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.LATEST_RELEASES_GO),this.context.currentLanguage)),'\n                    ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_141,currVal_141))) {
      this.renderer.setText(this._text_15,currVal_141);
      this._expr_141 = currVal_141;
    }
    valUnwrapper.reset();
    const currVal_144:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.HEADLINE_1),this.context.currentLanguage)),'\n                        ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_144,currVal_144))) {
      this.renderer.setText(this._text_18,currVal_144);
      this._expr_144 = currVal_144;
    }
    valUnwrapper.reset();
    const currVal_146:any = import4.interpolate(1,' ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.HEADLINE_2),this.context.currentLanguage)),'\n                    ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_146,currVal_146))) {
      this.renderer.setText(this._text_20,currVal_146);
      this._expr_146 = currVal_146;
    }
    this._NgSwitch_36_3.detectChangesInHostProps(this,this._el_36,throwOnChange);
    this._SearchableContentsComponent_36_4.detectChangesInHostProps(this,this._el_36,throwOnChange);
    valUnwrapper.reset();
    const currVal_148:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.LATEST_RELEASES),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_148,currVal_148))) {
      this.renderer.setText(this._text_43,currVal_148);
      this._expr_148 = currVal_148;
    }
    valUnwrapper.reset();
    const currVal_150:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.LATEST_RELEASES_SUB),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_150,currVal_150))) {
      this.renderer.setText(this._text_49,currVal_150);
      this._expr_150 = currVal_150;
    }
    valUnwrapper.reset();
    const currVal_153:any = import4.interpolate(1,'\n            ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_5,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.CATALOGUE_GO),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_153,currVal_153))) {
      this.renderer.setText(this._text_63,currVal_153);
      this._expr_153 = currVal_153;
    }
    this._ContentSpecialsComponent_68_3.detectChangesInHostProps(this,this._el_68,throwOnChange);
    valUnwrapper.reset();
    const currVal_155:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_6,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.SPECIALS),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_155,currVal_155))) {
      this.renderer.setText(this._text_77,currVal_155);
      this._expr_155 = currVal_155;
    }
    valUnwrapper.reset();
    const currVal_157:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_7,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.SPECIALS_SUB),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_157,currVal_157))) {
      this.renderer.setText(this._text_83,currVal_157);
      this._expr_157 = currVal_157;
    }
    valUnwrapper.reset();
    const currVal_159:any = import4.interpolate(1,'\n            ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_9,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.HOME.SPECIALS_GO),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_159,currVal_159))) {
      this.renderer.setText(this._text_98,currVal_159);
      this._expr_159 = currVal_159;
    }
    valUnwrapper.reset();
    const currVal_161:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_13,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.LEARN_MORE),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_161,currVal_161))) {
      this.renderer.setText(this._text_117,currVal_161);
      this._expr_161 = currVal_161;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_14_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_14_0:any = ((<any>this.context.utils.scroll(this._el_32,20)) !== false);
    return (true && pd_14_0);
  }
  private _handle_click_27_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_27_0:any = ((<any>this.context.utils.scroll(this._el_32,20)) !== false);
    return (true && pd_27_0);
  }
  private _handle_click_62_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_62_0:any = ((<any>this.context.utils.lLink('catalogue',this.context.currentLanguage)) !== false);
    return (true && pd_62_0);
  }
  private _handle_click_97_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_97_0:any = ((<any>this.context.utils.lLink('catalogue/special',this.context.currentLanguage)) !== false);
    return (true && pd_97_0);
  }
  private _handle_click_116_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_116_0:any = ((<any>this.context.utils.lLink('page/about',this.context.currentLanguage)) !== false);
    return (true && pd_116_0);
  }
}
export function viewFactory_HomeComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.HomeComponent> {
  if ((renderType_HomeComponent === (null as any))) { (renderType_HomeComponent = viewUtils.createRenderComponentType('',0,import16.ViewEncapsulation.None,styles_HomeComponent,{})); }
  return new _View_HomeComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _LoadingIndicator_2_4:import34.Wrapper_LoadingIndicator;
  _text_3:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent1,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'loading-indicator',new import4.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._el_2);
    var compView_2:any = import34.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(2),this._appEl_2);
    this._LoadingIndicator_2_4 = new import34.Wrapper_LoadingIndicator();
    this._appEl_2.initComponent(this._LoadingIndicator_2_4.context,([] as any[]),compView_2);
    compView_2.create(this._LoadingIndicator_2_4.context,([] as any[]),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.LoadingIndicator) && (2 === requestNodeIndex))) { return this._LoadingIndicator_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = '#B6B6B6';
    this._LoadingIndicator_2_4.check_color(currVal_2_0_0,throwOnChange,false);
    this._LoadingIndicator_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_HomeComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import21.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent2,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','record-listing-home'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import27.TemplateRef_(this._appEl_2,viewFactory_HomeComponent3);
    this._NgFor_2_6 = new import21.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parent.parentInjector.get(import28.IterableDiffers),this.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import31.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = (<_View_HomeComponent0>this.parent)._SearchableContentsComponent_36_4.context.dbContentsLimited(8);
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_HomeComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  /*private*/ _expr_14:any;
  /*private*/ _expr_15:any;
  _pipe_truncate_1_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent3,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_14 = import7.UNINITIALIZED;
    this._expr_15 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','record-item col-md-3 col-xs-6'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class',''),(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_3,'img',new import4.InlineArray2(2,'alt',''),(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','record-desc'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'div',new import4.InlineArray2(2,'class','catalogue-record-title gray-text text-uppercase letter-spacing-1'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_8,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n                    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_3,'click',this.eventHandler(this._handle_click_3_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_10,'click',this.eventHandler(this._handle_click_10_0.bind(this)));
    this._pipe_truncate_1_0 = import4.pureProxy2((<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1.transform.bind((<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_14:any = import4.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.cover.front,'');
    if (import4.checkBinding(throwOnChange,this._expr_14,currVal_14)) {
      this.renderer.setElementProperty(this._el_4,'src',this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL,currVal_14));
      this._expr_14 = currVal_14;
    }
    valUnwrapper.reset();
    const currVal_15:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_0,(<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1.transform)(this.context.$implicit.title,((this.parent.parent.context.config.data == (null as any))? (null as any): this.parent.parent.context.config.data.CATALOGUE.RECORD_TITLE_TRUNCATE))),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_11,currVal_15);
      this._expr_15 = currVal_15;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_3_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_3_0:any = ((<any>this.parent.parent.context.router.navigate([this.context.$implicit.url],{relativeTo: this.parent.parent.context.route.parent})) !== false);
    return (true && pd_3_0);
  }
  private _handle_click_10_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_10_0:any = ((<any>this.parent.parent.context.router.navigate([this.context.$implicit.url],{relativeTo: this.parent.parent.context.route.parent})) !== false);
    return (true && pd_10_0);
  }
}
function viewFactory_HomeComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  /*private*/ _expr_34:any;
  /*private*/ _expr_35:any;
  /*private*/ _expr_36:any;
  /*private*/ _expr_37:any;
  _pipe_truncate_1_1:any;
  /*private*/ _expr_39:any;
  _pipe_intl_0_8:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent4,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_34 = import7.UNINITIALIZED;
    this._expr_35 = import7.UNINITIALIZED;
    this._expr_36 = import7.UNINITIALIZED;
    this._expr_37 = import7.UNINITIALIZED;
    this._expr_39 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','col-md-6 col-sm-6 xs-margin-bottom-ten'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','model-details clearfix xs-no-margin'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','text-center col-md-6 no-padding'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'img',new import4.InlineArray4(4,'alt','','class','pointer'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','col-md-6 no-padding'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                        ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','special-text model-details-text'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','separator-line bg-black no-margin-lr margin-ten'),(null as any));
    this._text_14 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_11,'span',new import4.InlineArray2(2,'class','display-block clearfix xs-no-margin sm-display-none'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_17 = import4.createRenderElement(this.renderer,this._el_11,'span',new import4.InlineArray2(2,'class','text-uppercase font-weight-600 black-text letter-spacing-2'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_11,'span',new import4.InlineArray2(2,'class','text-uppercase text-small letter-spacing-2 margin-two display-block'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_11,'p',new import4.InlineArray2(2,'class','margin-ten xs-no-margin'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_26 = import4.createRenderElement(this.renderer,this._el_11,'span',new import4.InlineArray2(2,'class','margin-five xs-no-margin display-block clearfix xs-no-margin'),(null as any));
    this._text_27 = this.renderer.createText(this._el_11,'\n                            ',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_11,'a',new import4.InlineArray2(2,'class','bottom-align-text highlight-button-dark btn btn-very-small no-margin pointer'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._text_31 = this.renderer.createText(this._el_9,'\n                    ',(null as any));
    this._text_32 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    this._pipe_truncate_1_1 = import4.pureProxy2((<_View_HomeComponent0>this.parent)._pipe_truncate_1.transform.bind((<_View_HomeComponent0>this.parent)._pipe_truncate_1));
    var disposable_1:Function = this.renderer.listen(this._el_28,'click',this.eventHandler(this._handle_click_28_0.bind(this)));
    this._pipe_intl_0_8 = import4.pureProxy2((<_View_HomeComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_HomeComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._text_33
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_34:any = import4.interpolate(1,'',this.context.$implicit.image,'');
    if (import4.checkBinding(throwOnChange,this._expr_34,currVal_34)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL,currVal_34));
      this._expr_34 = currVal_34;
    }
    const currVal_35:any = import4.interpolate(1,'',this.context.$implicit.title[this.parent.context.currentLanguage],'');
    if (import4.checkBinding(throwOnChange,this._expr_35,currVal_35)) {
      this.renderer.setText(this._text_18,currVal_35);
      this._expr_35 = currVal_35;
    }
    const currVal_36:any = import4.interpolate(1,'',this.context.$implicit.subtitle[this.parent.context.currentLanguage],'');
    if (import4.checkBinding(throwOnChange,this._expr_36,currVal_36)) {
      this.renderer.setText(this._text_21,currVal_36);
      this._expr_36 = currVal_36;
    }
    valUnwrapper.reset();
    const currVal_37:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_1,(<_View_HomeComponent0>this.parent)._pipe_truncate_1.transform)(this.context.$implicit.content[this.parent.context.currentLanguage],((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.SPECIAL.TITLE_TRUNCATE))),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_37,currVal_37))) {
      this.renderer.setText(this._text_24,currVal_37);
      this._expr_37 = currVal_37;
    }
    valUnwrapper.reset();
    const currVal_39:any = import4.interpolate(1,'\n                            ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_8,(<_View_HomeComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.COMMON.SEE_MORE),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_39,currVal_39))) {
      this.renderer.setText(this._text_29,currVal_39);
      this._expr_39 = currVal_39;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.context.utils.lLink(this.context.$implicit.url,this.parent.context.currentLanguage)) !== false);
    return (true && pd_6_0);
  }
  private _handle_click_28_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this.parent.context.utils.lLink(this.context.$implicit.url,this.parent.context.currentLanguage)) !== false);
    return (true && pd_28_0);
  }
}
function viewFactory_HomeComponent4(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _ContentRecordsFeaturedComponent_4_3:import37.Wrapper_ContentRecordsFeaturedComponent;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _appEl_23:import3.AppElement;
  _TemplateRef_23_5:any;
  _NgFor_23_6:import21.Wrapper_NgFor;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  /*private*/ _expr_38:any;
  _pipe_intl_0_10:any;
  /*private*/ _expr_40:any;
  _pipe_intl_0_11:any;
  /*private*/ _expr_42:any;
  _pipe_intl_0_12:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent5,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_38 = import7.UNINITIALIZED;
    this._expr_40 = import7.UNINITIALIZED;
    this._expr_42 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'section',new import4.InlineArray2(2,'class','bg-gray content-section wow fadeIn '),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray4(4,'class','row col-md-12 ','content-records-featured',''),(null as any));
    this._ContentRecordsFeaturedComponent_4_3 = new import37.Wrapper_ContentRecordsFeaturedComponent(this.parentInjector.get(import11.ContentService),this.parentInjector.get(import12.UtilsService),this.parentInjector.get(import14.ActivatedRoute),this.parentInjector.get(import15.Router),this.parentInjector.get(import26.ElasticSearchService));
    this._text_5 = this.renderer.createText(this._el_4,'\n\n            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'div',new import4.InlineArray2(2,'class','col-md-12 text-center'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_8,'h3',new import4.InlineArray2(2,'class','section-title section-title-services no-padding-bottom'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_6,'div',new import4.InlineArray2(2,'class','col-md-5 col-sm-11 margin-five center-col text-center'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                    ',(null as any));
    this._el_16 = import4.createRenderElement(this.renderer,this._el_14,'h4',new import4.InlineArray2(2,'class','gray-text'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._text_19 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_4,'\n\n\n            ',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','record-listing'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_21,(null as any));
    this._appEl_23 = new import3.AppElement(23,21,this,this._anchor_23);
    this._TemplateRef_23_5 = new import27.TemplateRef_(this._appEl_23,viewFactory_HomeComponent6);
    this._NgFor_23_6 = new import21.Wrapper_NgFor(this._appEl_23.vcRef,this._TemplateRef_23_5,this.parentInjector.get(import28.IterableDiffers),this.parent.ref);
    this._text_24 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_4,'\n\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','learn-more row col-md-12 col-sm-12 center-col text-center'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n        ',(null as any));
    this._el_30 = import4.createRenderElement(this.renderer,this._el_28,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-medium button xs-margin-bottom-five'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'',(null as any));
    this._text_32 = this.renderer.createText(this._el_28,'\n    ',(null as any));
    this._text_33 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_intl_0_10 = import4.pureProxy2((<_View_HomeComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_HomeComponent0>this.parent)._pipe_intl_0));
    this._pipe_intl_0_11 = import4.pureProxy2((<_View_HomeComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_HomeComponent0>this.parent)._pipe_intl_0));
    var disposable_0:Function = this.renderer.listen(this._el_30,'click',this.eventHandler(this._handle_click_30_0.bind(this)));
    this._pipe_intl_0_12 = import4.pureProxy2((<_View_HomeComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_HomeComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._text_33
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import31.NgFor) && (23 === requestNodeIndex))) { return this._NgFor_23_6.context; }
    if (((token === import38.ContentRecordsFeaturedComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 25)))) { return this._ContentRecordsFeaturedComponent_4_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._ContentRecordsFeaturedComponent_4_3.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_23_0_0:any = this._ContentRecordsFeaturedComponent_4_3.context.dbContentsLimited(4);
    this._NgFor_23_6.check_ngForOf(currVal_23_0_0,throwOnChange,false);
    this._NgFor_23_6.detectChangesInInputProps(this,this._anchor_23,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentRecordsFeaturedComponent_4_3.detectChangesInHostProps(this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_38:any = import4.interpolate(1,'\n                        ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_10,(<_View_HomeComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.HOME.FEATURED),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_38,currVal_38))) {
      this.renderer.setText(this._text_11,currVal_38);
      this._expr_38 = currVal_38;
    }
    valUnwrapper.reset();
    const currVal_40:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_11,(<_View_HomeComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.HOME.FEATURED_SUB),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_40,currVal_40))) {
      this.renderer.setText(this._text_17,currVal_40);
      this._expr_40 = currVal_40;
    }
    valUnwrapper.reset();
    const currVal_42:any = import4.interpolate(1,'\n                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_12,(<_View_HomeComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.HOME.CATALOGUE_GO),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_42,currVal_42))) {
      this.renderer.setText(this._text_31,currVal_42);
      this._expr_42 = currVal_42;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_30_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_30_0:any = ((<any>this.parent.context.utils.lLink('catalogue',this.parent.context.currentLanguage)) !== false);
    return (true && pd_30_0);
  }
}
function viewFactory_HomeComponent5(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_truncate_1_2:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent6,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_18 = import7.UNINITIALIZED;
    this._expr_19 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','record-item col-md-3 col-xs-6'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class',''),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'img',new import4.InlineArray2(2,'alt',''),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','record-desc'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'div',new import4.InlineArray2(2,'class','catalogue-record-title gray-text text-uppercase letter-spacing-1'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_14,'click',this.eventHandler(this._handle_click_14_0.bind(this)));
    this._pipe_truncate_1_2 = import4.pureProxy2((<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1.transform.bind((<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_18:any = import4.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.cover.front,'');
    if (import4.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import36.SecurityContext.URL,currVal_18));
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import4.interpolate(1,'\n                                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_truncate_1_2,(<_View_HomeComponent0>this.parent.parent)._pipe_truncate_1.transform)(this.context.$implicit.title,'80')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_15,currVal_19);
      this._expr_19 = currVal_19;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.parent.context.router.navigate([this.context.$implicit.url],{relativeTo: this.parent.parent.context.route.parent})) !== false);
    return (true && pd_4_0);
  }
  private _handle_click_14_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_14_0:any = ((<any>this.parent.parent.context.router.navigate([this.context.$implicit.url],{relativeTo: this.parent.parent.context.route.parent})) !== false);
    return (true && pd_14_0);
  }
}
function viewFactory_HomeComponent6(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_HomeComponent7 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_HomeComponent7,renderType_HomeComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_1 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'span',import4.EMPTY_INLINE_ARRAY,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_1:any = this.parent.context.about.summary[this.parent.context.currentLanguage];
    if (import4.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'innerHTML',this.viewUtils.sanitizer.sanitize(import36.SecurityContext.HTML,currVal_1));
      this._expr_1 = currVal_1;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_HomeComponent7(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_HomeComponent7(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/home.component.ngfactory.ts